import { store } from '@store/index';
import { authAppSlice } from '@store/slices/authApp.slice';

export const clearLocalDataBeforeRedirection = () => {
  store.dispatch(authAppSlice.actions.clear());
  localStorage.removeItem('applicationId');
  localStorage.removeItem('clientOrganizationId');
  localStorage.removeItem('selectedConfigurationId');
};
